import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ParkingsService } from '../../service/main/parkings.service';
import { SettingsService } from '../../service/common/settings.service';
import { ToastrService } from '../../service/common/toastr.service';
import Enums from '../../utils/enums';
import { Parking, Company, Scheduler, ParkingTariff, ParkingLotSensor, UpdateParking } from '../../entity';


@Component({
    selector: 'app-parking-lot-detail',
    templateUrl: './parking-lot-detail.component.html',
    styleUrls: ['./parking-lot-detail.component.css']
})
export class ParkingLotDetailComponent implements OnInit {
    public parking: Parking = {
        Title: '',
        Company: {
            Title: ''
        }
    };
    public schedulers: Array<Scheduler>;
    public parkingTariffs: Array<ParkingTariff>;
    public parkingLotSensors: Array<ParkingLotSensor> = [];

    isEditable = false;

    sensorsMapLng: number;
    sensorsMapLat: number;
    sensorsMapZoom: number;

    editorShown = false;
    editedSensor: ParkingLotSensor = {
        Latitude: 0,
        Longitude: 0
    };

    days: Array<number> = [null, 1, 2, 3, 4, 5, 6, 7];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private parkingService: ParkingsService,
        private settingsService: SettingsService,
        private toastr: ToastrService,
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {

        this.parkingService.getParkingLotDetail(this.route.snapshot.data['parking']).subscribe(res => {
            const parking = new Parking();
            parking.fromObject(res);

            parking.Company = new Company();
            parking.Company.fromObject(res.company);

            this.parking = parking;
        }, err => {
            this.toastr.error('An error occured while loading detail of parking.');
        });

        this.parkingService.getParkingSchedules(this.route.snapshot.data['parking']).subscribe(res => {
            const schedulers = new Array<Scheduler>();
            res.forEach(resScheduler => {
                const scheduler = new Scheduler();
                scheduler.fromObject(resScheduler);

                scheduler.Day = this.settingsService.DAY_OF_WEEK_BY_ID(scheduler.DayOfWeek);

                schedulers.push(scheduler);
            });
            this.schedulers = schedulers;
        }, err => {
            this.toastr.error('An error occured while loading detail of parking.');
        });

        this.parkingService.getParkingTariffs(this.route.snapshot.data['parking']).subscribe(res => {
            const parkingTariffs = new Array<ParkingTariff>();
            res.forEach(pt => {
                const parkingTariff = new ParkingTariff();
                parkingTariff.fromObject(pt);

                parkingTariff.Tariff = Number(parkingTariff.Price.split(' ')[0]);

                parkingTariffs.push(parkingTariff);
            });
            this.parkingTariffs = parkingTariffs;
        }, err => {
            this.toastr.error('An error occured while loading detail of parking.');
        });

        this.parkingService.getParkingSensors(this.route.snapshot.data['parking']).subscribe(res => {
            const parkingLotSensors = new Array<ParkingLotSensor>();
            res.forEach(pls => {
                const parkingLotSensor = new ParkingLotSensor();
                parkingLotSensor.fromObject(pls);

                parkingLotSensors.push(parkingLotSensor);
            });
            this.parkingLotSensors = parkingLotSensors;
            this.setMapPosition();
        }, err => {
            this.toastr.error('An error occured while loading detail of parking.');
        });
    }

    showEditable() {
        this.isEditable = !this.isEditable;
    }

    onSubmitForm(form: NgForm) {
        if (form.valid) {
            const update = new UpdateParking(
                this.parking.ParkingID,
                this.parking.ParkingTypeID,
                this.parking.ParkingLevelID,
                this.parking.Title,
                this.parking.Phone,
                this.parking.Email,
                form.value.latitude,
                form.value.longitude,
                form.value.address,
                form.value.location,
                form.value.contact,
                this.schedulers
            );

            // console.log(this.parkingTariffs);

            this.parkingService.updateParking(update).subscribe(result => {
                this.toastr.success(`Parking details was succesfully edited.`);
                this.refresh();
                this.showEditable();
            }, err => {
                this.toastr.success(`An error occured while editing details of parking.`);
            });
        }
    }

    deleteParkingLotSensor(plSensor: ParkingLotSensor) {
        this.parkingService.deleteParkingLotSensor(plSensor).subscribe(response => {
            if (response.ok) {
                const findIndex = this.parkingLotSensors.findIndex(item => item.ParkingLotSensorID === plSensor.ParkingLotSensorID);
                this.parkingLotSensors.splice(findIndex, 1);
                this.toastr.success(`Sensor ${plSensor.RegistrationNumber} succesfully removed!`);
            } else {
                this.toastr.success(`Sensor ${plSensor.RegistrationNumber} could not be removed!`);
            }
        }, error => {
            this.toastr.error(`A error has occurred while removing sensor: ${plSensor.RegistrationNumber}.`);
        });
    }

    getSensorIconByStateID(stateID) {
        switch (stateID) {
            case Enums.eParkingLotStat.Free:
                return '../../../assets/sensors/free-sensor-pin.png';
            case Enums.eParkingLotStat.Occupied:
                return '../../../assets/sensors/booked-sensor-pin.png';
            case Enums.eParkingLotStat.Booked:
                return '../../../assets/sensors/sensor-pin.png';
        }
    }

    setMapPosition() {
        if (this.parkingLotSensors.length <= 0) {
            return;
        }

        let minX, maxX, minY, maxY;

        // init first point
        ((point) => {
            minX = point.Latitude;
            maxX = point.Latitude;
            minY = point.Longitude;
            maxY = point.Longitude;
        })(this.parkingLotSensors[0]);

        // calculate rect
        this.parkingLotSensors.map((point) => {
            minX = Math.min(minX, point.Latitude);
            maxX = Math.max(maxX, point.Latitude);
            minY = Math.min(minY, point.Longitude);
            maxY = Math.max(maxY, point.Longitude);
        });

        const midX = (minX + maxX) / 2;
        const midY = (minY + maxY) / 2;
        const midPoint = [midX, midY];

        const deltaX = (maxX - minX);
        const deltaY = (maxY - minY);


        const region = {
            lat: midX,
            lng: midY,
            latitudeDelta: deltaX,
            longitudeDelta: deltaY,
        };

        const zoom = Math.round(Math.log(360 / region.longitudeDelta) / Math.LN2);

        this.sensorsMapLat = region.lat;
        this.sensorsMapLng = region.lng;
        this.sensorsMapZoom = zoom - 2;
    }

    showEditor() {
        this.editorShown = !this.editorShown;
    }

    cancelMapSensor() {
        this.editedSensor = {
            Longitude: 0,
            Latitude: 0
        };
        this.showEditor();
        document.getElementById('endElement').scrollIntoView();
    }

    editSensor(sensor) {
        this.editedSensor = sensor;

        this.showEditor();
    }

    updateMapSensor() {
        const errors = [];
        if (!this.editedSensor.RegistrationNumber) {
            errors.push('Registration number');
        }
        if (!this.editedSensor.ParkingLotNo) {
            errors.push('Parking lot number');
        }

        if (errors.length > 0) {
            this.toastr.error(`Sensor has errors, will not be updated ${errors.join(', ')}!`);
        } else {
            this.editedSensor.ParkingID = this.parking.ParkingID;

            this.parkingService.updateParkingLotSensor(this.editedSensor).subscribe(response => {
                if (response) {
                    const parkingLotSensor = new ParkingLotSensor();
                    parkingLotSensor.fromObject(response);

                    if (this.editedSensor.ParkingLotSensorID) {
                        const findIndex = this.parkingLotSensors.findIndex(item =>
                            item.ParkingLotSensorID === this.editedSensor.ParkingLotSensorID);
                        this.parkingLotSensors.splice(findIndex, 1);
                    }

                    this.parkingLotSensors.push(parkingLotSensor);
                    this.cancelMapSensor();
                    this.toastr.success(`Sensor was updated succesfully`);
                } else {
                    this.toastr.error(`Sensor ${this.editedSensor.RegistrationNumber} could not be updated!`);
                }
            }, error => {
                this.toastr.error(`A error has occurred while removing sensor: ${this.editedSensor.RegistrationNumber}.`);
            });
        }
    }

    onSelectDay(day: number) {
        const findIndex = this.schedulers.findIndex(item => item.DayOfWeek === day);
        if (findIndex === -1) {
            const _schedulers = new Array<Scheduler>();
            this.schedulers.forEach(item => {
                const scheduler = new Scheduler();
                scheduler.fromObject(item);

                _schedulers.push(scheduler);
            });
            if (day == null) {
                _schedulers.forEach((item) => {
                    if (item.DayOfWeek != null) {
                        const findIndex = this.schedulers.findIndex(scheduler => scheduler.DayOfWeek === item.DayOfWeek);
                        this.schedulers.splice(findIndex, 1);
                    }
                });
            } else if (day != null) {
                _schedulers.forEach((item, index) => {
                    if (item.DayOfWeek == null) {
                        this.schedulers.splice(index, 1);
                    }
                });
            }

            const scheduler = new Scheduler();

            scheduler.DayOfWeek = day;
            scheduler.Day = this.settingsService.DAY_OF_WEEK_BY_ID(day);

            if (day == null) {
                scheduler.SchedulerTypeID = Enums.eSchedulerType.Standard;
            } else {
                scheduler.SchedulerTypeID = Enums.eSchedulerType.Daily;
            }

            this.schedulers.push(scheduler);
        } else {
            this.schedulers.splice(findIndex, 1);
        }

        this.schedulers.sort((a, b) => {
            if (a.DayOfWeek < b.DayOfWeek) {
                return -1;
            } else if (a.DayOfWeek > b.DayOfWeek) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    isDaySelected(day: number) {
        const findIndex = this.schedulers.findIndex(item => item.DayOfWeek === day);
        if (findIndex === -1) {
            return false;
        } else {
            return true;
        }
    }

    getFirstLetter(day: number) {
        switch (day) {
            case null:
                return 'M - S';
            case Enums.eDayOfWeek.Monday:
                return 'M';
            case Enums.eDayOfWeek.Tuesday:
                return 'T';
            case Enums.eDayOfWeek.Wednesday:
                return 'W';
            case Enums.eDayOfWeek.Thursday:
                return 'T';
            case Enums.eDayOfWeek.Friday:
                return 'F';
            case Enums.eDayOfWeek.Saturday:
                return 'S';
            case Enums.eDayOfWeek.Sunday:
                return 'S';
        }
    }
}
